"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _primitives = require("../../platform/primitives");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-bottom-width: 0;\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A horizontal divider whose width and spacing can be adjusted
 */
var Separator = _primitives.styled.View(_templateObject(), (0, _helpers.color)("black10"), _styledSystem.space, _styledSystem.width);

exports.Separator = Separator;
Separator.defaultProps = {
  width: "100%"
};
//# sourceMappingURL=Separator.js.map